import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    countryList: [],
    popularCountries: [],
    insurersList: [],
    sumAssuredList: [],
    relationList: [],
    nomineeRelationList: [],
    ageList: [],
    durationDaysList: [],
    tripTypeList:[]
}

const MastersDataSlice = createSlice({
    name: 'mastersData',
    initialState,
    reducers: {
        updateMastersData: (state, action) => {
            Object.assign(state, action.payload);
        },
        resetMastersData: () => initialState
    }

});

export const { updateMastersData, resetMastersData } = MastersDataSlice.actions;

export default MastersDataSlice.reducer;
